<template>
    <div class="story-maker-sticker story-maker-sticker-product" :class="{edit : isEditing}">
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="finish">Terminé</p>
        <div class="sticker sticker-product">
           <div class="icon"></div>
            <p>{{ products.length == 1 ? products[0].text : `${products.length} produits` }}</p>
        </div>
        <div class="options">

            <div class="list-option-text hide-scrollbar">
                <div class="texts">
                    <div class="text modern modern-font">Modern</div>
                    <div class="text classic classic-font active">Classic</div>
                    <div class="text signature signature-font">Signature</div>
                    <div class="text editor editor-font">Editor</div>
                    <div class="text poster poster-font">Poster</div>
                    <div class="text bubble bubble-font">Bubble</div>
                    <div class="text deco deco-font">Deco</div>
                    <div class="text squeeze squeeze-font">Squeeze</div>
                    <div class="text typewriter typewriter-font">Typewriter</div>
                    <div class="text strong strong-font">Strong</div>
                    <div class="text meme meme-font">Meme</div>
                    <div class="text elegant elegant-font">Elegant</div>
                    <div class="text directional directional-font">Directional</div>
                    <div class="text literature literature-font">Literature</div>
                </div>
            </div>

            <div class="list-option-color">
                <div class="pipette"><div class="icon"></div></div>
                <div class="color-carousel">
                    <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="()=>{}" >
                        <Slide v-for="(colors,index) in [['#ffffffff','#000000','#4397EF','#70C04F','#F6CB5B','#F08C34','#EA4857','#D12D69','#EA3323'],['#EA3323','#ED858E','#F7D0D1','#FADAB4','#F5C281','#D18E47','#99643A','#432324','#1D4A29'],['#262626','#363636','#555555','#737373','#999999','#B2B2B2','#C7C7C7','#DBDBDB','#EFEFEF']]" :key="index">
                            <div v-for="colorHexa in colors" class="color" :style="`background-color:${colorHexa}`"></div>
                        </Slide>
                    </carousel>
                        
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    export default {
        components: {
            Carousel,
            Slide
        },
        props: {
            id: [Number, String],
            isEditing: Boolean,
            products: Array,
            isPreventCover: Boolean,
            isCover: Boolean,
            setCover: Function,
            setCbClick: Function,
        },

        data() {
            return {
                timeoutFinish: null
            }
        },

        methods: {
            finish() {
                
                this.$emit('updateSticker',this.id , {
                    isEditing: false,
                })

                if (this.timeoutFinish) clearTimeout(this.timeoutFinish)
                this.timeoutFinish = setTimeout(() => {
                    this.setCover(false)
                }, 200);
 
            },
        },
    }
</script>
